import React, { useState } from 'react'
import useS3Upload from 'hooks/useS3Upload'
import Icon from 'components/Icon'
import classNames from 'classnames'

export default function EditableImg({
  children,
  presignedUploadUrl,
  onChange,
  disabled = false,
  name,
  className,
  accept = 'image/*',
  deleteable = false,
}) {
  const [uploading, setUploading] = useState(false)

  const { getRootProps, getInputProps, isDragActive } = useS3Upload({
    accept,
    disabled,
    presignedUploadUrl: disabled ? null : presignedUploadUrl,
    onUploadStart: () => setUploading(true),
    onUploadReady: (url, file) => {
      setUploading(false)
      onChange(url.split('?')[0] + '?' + Date.now(), file)
    },
  })

  const { className: rootClassName, ...rootProps } = getRootProps()
  const { className: inputClassName, ...inputProps } = getInputProps()

  return (
    <div className={classNames('group', { 'p-1': !disabled })} onClick={(e) => e.stopPropagation()}>
      <div className={classNames('relative', {
        'border-2 border-gray-300 border-dashed shadow-inner': !disabled,
      })}>
        { !disabled && deleteable &&
          <Icon
            icon="times"
            className="text-xl text-gray-900 cursor-pointer hover:text-negative top-1 right-2 absolute z-10"
            onClick={(event) => {
              event.preventDefault()
              event.stopPropagation()
              onChange(null)
            }}
          />
        }

        <div
          {...rootProps}
          className={classNames(className, rootClassName, 'relative', {
            'cursor-copy': !disabled,
          })}
        >
          {!disabled && (
            <>
              {isDragActive ? (
                <div className="absolute top-0 left-0 w-full h-full opacity-75 bg-gray-400 flex items-center justify-center">
                  <Icon icon="file-upload" />
                </div>
              ) : uploading ? (
                <div className="absolute top-0 left-0 w-full h-full opacity-50 bg-gray-100 flex items-center justify-center">
                  <Icon icon="spinner-third" className="animate-spin" />
                </div>
              ) : (
                <div className="w-full h-full absolute top-0 left-0 opacity-50 flex items-center justify-center p-10" />
              )}
            </>
          )}

          { children }

          <input
            className={classNames(inputClassName, 'hidden w-0 h-0')}
            {...inputProps}
          />
        </div>
      </div>
    </div>
  )
}
